import { StrictMode } from 'react';
import '@group-ui/group-ui-css-framework/dist/groupui-minify.css';
import { defineCustomElements } from '@group-ui/group-ui-react/node_modules/@group-ui/group-ui/dist/components';
import '@group-ui/group-ui-react/node_modules/@group-ui/group-ui/dist/group-ui/assets/themes/tokens.css';
import { createRoot } from 'react-dom/client';
import './locales/i18n.ts';
import './index.css';
import { AppMain } from '@/index.tsx';

void defineCustomElements();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppMain />
  </StrictMode>
);
